import React, { FC, useCallback, useContext, useMemo } from 'react';
import { AuthContext, CommonContext, Wallet } from '@repo-level/core-front';

import { mapCurrencyFlags, mapCurrencyFullName } from 'helpers/currency';
import { useCurrentOptionWallet } from 'hooks/wallet';
import { formatWalletValue } from 'helpers/wallet';

import { ScCurrenciesBlock } from '../EditCurrencies/styled';
import { ScCurrenciesItem, ScCurrenciesItems } from '../styled';
import { ImageComponent } from 'components/Image';

export const MyCurrencyItems: FC<{ onClose?: () => void }> = (props) => {
  const { wallets } = useContext(AuthContext);

  return (
    <ScCurrenciesBlock>
      <ScCurrenciesItems>
        {wallets.map((account) => (
          <CurrencyItem key={account.currency} {...account} {...props} />
        ))}
      </ScCurrenciesItems>
    </ScCurrenciesBlock>
  );
};

interface CurrencyItemProps extends Wallet {
  onClose?: () => void;
}

const CurrencyItem: FC<CurrencyItemProps> = ({
  currency,
  amountCents,
  onClose,
}) => {
  const { changeUserWallet } = useContext(AuthContext);
  const { currencies } = useContext(CommonContext);
  const currentOptionWallet = useCurrentOptionWallet();

  const walletValue = useMemo(
    () => formatWalletValue(currency, amountCents, currencies, true),
    [amountCents, currencies, currency]
  );

  const isCurrentCurrency = useMemo(
    () => currentOptionWallet.currency === currency,
    [currency, currentOptionWallet.currency]
  );

  const onClick = useCallback(() => {
    changeUserWallet(currency);
    onClose && onClose();
  }, [changeUserWallet, currency, onClose]);

  const icon = useMemo(() => mapCurrencyFlags[currency], [currency]);

  return (
    <ScCurrenciesItem active={isCurrentCurrency} onClick={onClick}>
      <div className="content">
        {icon && <ImageComponent width={24} height={24} src={icon} alt="" />}
        <div>
          {walletValue} | {mapCurrencyFullName[currency]}
        </div>
      </div>
    </ScCurrenciesItem>
  );
};
